import { Box, CircularProgress, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import backbluebtn from "../../../Utils/Images/backbluebtn.png";
import { GetSingleCoupon } from "../../../APIs/Function/Coupon/Singlecoupon";
import CustomButton from "../../../Components/Button/CustomButton";

const SingleCoupon = () => {
  const [singleCoupon, setSingleCoupon] = useState({});
  const [loading, setLoading] = useState(false);
  const { id } = useParams();

  const handleSingleCoupon = async () => {
    try {
      setLoading(true)
      let res = await GetSingleCoupon(id);
      setSingleCoupon(res.r);
      setLoading(false)
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    handleSingleCoupon();
  }, []);
  console.log(singleCoupon);
  return (
    <>
      {loading ? (
        <Box sx={{ mt: "25%" }}>
          <CircularProgress></CircularProgress>
        </Box>
      ) : (
        <Box>
          <Box
            sx={{
              bgcolor: "#31AEF4",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              height: { xs: "50px", md: "70px", lg: "70px" },
              p: "10px",
              boxSizing: "border-box",
            }}
          >
            <Link to={"/coupon"}>
              <Box
                sx={{
                  height: { xs: "50px", md: "60px", lg: "60px" },
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <img height={"100%"} src={backbluebtn} alt="back" />
              </Box>
            </Link>
            <Box>
              <Typography
                sx={{
                  fontFamily: "Open Sans",
                  fontSize: { md: "30px", sm: "20px" },
                  fontWeight: 600,
                  lineHeight: "36px",
                  color: "#FFFFFF",
                }}
              >
                Coupon Details
              </Typography>
            </Box>
            <Box>
              <Link to={`/editcoupon/${singleCoupon.id}`}>
                <CustomButton
                  sx={{
                    width: { xs: "40px", md: "50px", lg: "80px" },
                    height: { xs: "10px", md: "50px", lg: "50px " },
                  }}
                >
                  Edit
                </CustomButton>
              </Link>
            </Box>
          </Box>
          <Box sx={{ display: "flex", height: "80vh" }}>
            {/* details box */}
            <Box
              sx={{
                width: "50%",
                m: "auto",
                border: "1px solid #E8E8E8",
                p: 2,
                boxSizing: "border-box",
                textAlign: "left",
                textAlign: "center",
              }}
            >
              <Box sx={{ p: 2, boxSizing: "border-box", mt: 2 }}>
                <Typography>
                  Coupon Code : {singleCoupon.coupon_code}
                </Typography>
              </Box>
              <Box sx={{ p: 2, boxSizing: "border-box", mt: 2 }}>
                <Typography>
                  Description : {singleCoupon.description}
                </Typography>
              </Box>
              <Box sx={{ p: 2, boxSizing: "border-box", mt: 2 }}>
                <Typography>
                  Discount Type : {singleCoupon.discount_type}
                </Typography>
              </Box>
              <Box sx={{ p: 2, boxSizing: "border-box", mt: 2 }}>
                <Typography>
                  Discount Value : {singleCoupon.discount_value}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      )}
    </>
  );
};

export default SingleCoupon;
